import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { initFirebase } from '@/lib/firebase';
import { useLocation, useNavigate } from 'react-router-dom';

export default function AuthGate({ children }: { children: JSX.Element }) {
  const [ready, setReady] = useState(false);
  const [authed, setAuthed] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    (async () => {
      const ctx = await initFirebase();
      if (!ctx) { setReady(true); setAuthed(false); return; }
      const auth = getAuth();
      const unsub = onAuthStateChanged(auth, (u) => {
        setAuthed(!!u);
        setReady(true);
        if (!u && loc.pathname !== '/login' && loc.pathname !== '/register') {
          navigate('/login');
        }
      });
      return () => unsub();
    })();
  }, [loc.pathname]);

  if (!ready) return null;
  if (!authed) return null;
  return children;
}

